define('bizzabo/models/Day',[
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'backbone',
    'backbone-validation',
    'underscore',
    'bizzabo/models/SyncedModel',
    'bizzabo/models/ValidationObject',
    'bizzabo/models/Session',
    'bizzabo/models/Sessions',
    'bizzabo/models/Track',
    'bizzabo/models/Tracks',
    'bizzabo/models/RelationsCollection'
], function(
    BZAPI,
    UTILS,
    Consts,
    Backbone,
    BackboneValidation,
    _,
    SyncedModel,
    ValidationObject,
    Session,
    Sessions,
    Track,
    Tracks,
    RelationsCollection
    ) {

    var Day = SyncedModel.extend({

        defaults : {
            'index' : 0
        },

        validationObject : undefined,

        sync : function(method, model, options) {
            if (method == 'delete') {
                // Leave this empty in order to support local destroy() calls
            }
        },

        initialize : function(map) {
            if (map && map['session']) {
                var newSessions = new Sessions(map['session']);
                this.set({
                    session : newSessions
                });
            }
            if (map && map['track']) {
                var newTracks = new Tracks(map['track']);
                this.set({
                    track : newTracks
                });
            }
            if (map && map['relation-session-track']) {
                var newRelations = new RelationsSessionTrack(map['relation-session-track']);
                this.set({
                    'relation-session-track' : newRelations
                });
            }

            if (!this.has("session")) {
                var newSessions = new Sessions();
                this.set({
                    session : newSessions
                });
            }
            if (!this.has("track")) {
                var newTrack = new Track();
                var newTracks = new Tracks();
                newTracks.add(newTrack);
                this.set({
                    track : newTracks
                });
            }
            this.get("track").comparator = function(track) {
                return track.get("index");
            };
            if (!this.has("relation-session-track")) {
                var newRelation = new RelationsSessionTrack();
                this.set({
                    'relation-session-track' : newRelation
                });
            }
            this.get("relation-session-track").initRelation(this.get("session"), "session", this.get("track"), "track");
            this.validationObject = new ValidationObject(this);

            this.sessionErrors = {};
            this.listenTo(this.get('session'), 'validated', this.sessionsValidated);
            this.listenTo(this.get('session'), 'remove', this.removedSessions);
        },

        sessionsValidated : function(isValid, model, errors) {
            if (isValid) {
                model.cid && this.sessionErrors[model.cid] && delete this.sessionErrors[model.cid];
            } else {
                this.sessionErrors[model.cid] = errors;
            }

            var numberOfInvalidSessions = _.size(this.sessionErrors);
            this.trigger('dayValidated', (numberOfInvalidSessions <= 0), this, this.sessionErrors);
        },

        removedSessions : function(model) {
            this.sessionsValidated(true, model);
        },

//	parse : function(response) {
//		var sessions = new Sessions(response.session);
//		var tracks = new Tracks(response.track);
//		var relations = new RelationsSessionTrack(response.relation);
//		var index = this.get("index");
//
//		return {
//			session : sessions,
//			track : tracks,
//			relation : relations,
//			index : index
//		};
//	},

        validation : {
            track : [
                {
                    required : true,
                    msg : 'Track is required'
                },
                {
                    rangeLength : [1, Consts.UI.agenda.MAX_NUM_OF_TRACKS],
                    msg : 'Invalid Tracks'
                }
            ],
            index : [
                {
                    required : true,
                    msg : 'Day index is required'
                },
                {
                    range : [0, Consts.UI.agenda.MAX_NUM_OF_DAYS],
                    msg : 'Too many days (max' + Consts.UI.agenda.MAX_NUM_OF_DAYS + ')'
                }
            ],
            session : {
                fn : function(value) {
                    this.validateSessions(value);
                }
            }
        },

        getSessionsInTrack : function(track, sessions, relationsSessionTrack) {
            sessions = sessions || this.get("session");
            relationsSessionTrack = relationsSessionTrack || this.get("relation-session-track");
            return relationsSessionTrack.joinByIdOrCid(track, sessions);
        },

        getTracksForSession : function(session) {
            return this.get("relation-session-track").joinByIdOrCid(session);
        },

        getExtremeSession : function(isFirst) {
            return UTILS.getExtremeModel(this.get("session"), isFirst ? "start" : "end", true);
        },

        getCollidingSessionsCids : function(sessions, relationsSessionTrack, tracks) {
            var res = {};
            for (var trackIndex = 0; trackIndex < tracks.length; trackIndex++) {
                var track = tracks.at(trackIndex);

                var sessionsInTrack = this.getSessionsInTrack(track, sessions, relationsSessionTrack);

                for (var sessionIndex1 = 0; sessionIndex1 < sessionsInTrack.length; sessionIndex1++) {
                    var session1 = sessionsInTrack[sessionIndex1];

                    for (var sessionIndex2 = (sessionIndex1 + 1); sessionIndex2 < sessionsInTrack.length; sessionIndex2++) {
                        var session2 = sessionsInTrack[sessionIndex2];

                        if (session1.cid != session2.cid && session2.get("end") > session1.get("start") && session2.get("start") < session1.get("end")) {
                            res[session1.cid] = true;
                            res[session2.cid] = true;
                        }
                    }
                    session1.set({
                        isColliding : _.has(res, session1.cid)
                    });
                }
            }
            return _.keys(res);
        },

        setSessionToTracks: function(session, firstTrack, lastTrack) {
            var relationsSessionTrack = this.get("relation-session-track")
            var oldTracks = this.getTracksForSession(session);
            for (var i = 0; i < oldTracks.length; i++) {
                var track = oldTracks[i];
                relationsSessionTrack.removeRelation(session, track);
            }
            for (var i = firstTrack; i < lastTrack; i++) {
                var track = this.get('track').at(i);
                track && relationsSessionTrack.addRelation(session, track);
            }
        },

        validateSessionCollisions : function(sessions, relationsSessionTrack, tracks) {
            sessions = sessions ? sessions : this.get("session");
            relationsSessionTrack = relationsSessionTrack ? relationsSessionTrack : this.get("relation-session-track");
            tracks = tracks ? tracks : this.get("track");

            if (this.getCollidingSessionsCids(sessions, relationsSessionTrack, tracks).length > 0) {
                return "sessions must not overlap";
            }
        },

        validateSessions : function(sessions) {
            var error = undefined;
            sessions = sessions ? sessions : this.get("session");

            // session validation
            for (var sessionIndex in sessions.models) {
                var session = sessions.at(sessionIndex);
                if (!session.isValid(true)) {
                    error = "an invalid session was detected";
                }
            }

            // validate collisions
            error = this.validateSessionCollisions(sessions) || error;
            return error;
        },

        addNewSession : function(map, trackIndexes) {
            var sessions = this.get("session");
            var newSession = (map instanceof Session) ? map : new Session(map);
            var relationsSessionTrack = this.get("relation-session-track");
            var tracks = this.get("track");
            for (var i = 0; i < trackIndexes.length; i++) {
                var currentIndex = trackIndexes[i];
                var track = tracks.where({
                    index : currentIndex
                })[0];
                track && relationsSessionTrack.addRelation(newSession, track);
            }

            sessions.add(newSession);
            this.wasChangedFromForm = true; // todo remove when editAgendaView have mixins
            this.isSynced = false;
            return newSession;
        },

        addNewTrack : function(track) {
            var currentTracks = this.get("track");
            if (!(track instanceof Track)) {
                var newIndex = currentTracks.length;
                track = new Track({
                    'name' : "",
                    'index' : newIndex
                });
            }
            currentTracks.add(track);
            this.wasChangedFromForm = true; // todo remove when editAgendaView have mixins
            this.isSynced = false;
        },

        removeTrack : function(track) {
            // remove relations
            var sessionsInTrack = this.getSessionsInTrack(track);
            var relationsSessionTrack = this.get("relation-session-track");
            for (var i = 0; i < sessionsInTrack.length; i++) {
                var session = sessionsInTrack[i];
                relationsSessionTrack.removeRelation(session, track);
            }

            // find sessions with no track
            var idMap = {}, cidMap = {};
            for (var j = 0; j < relationsSessionTrack.length; j++) {
                var relation = relationsSessionTrack.at(j);
                var id = relation.get("session-id");
                var cid = relation.get("session-cid");
                id && (idMap[id] = true);
                cid && (cidMap[cid] = true);
            }

            // remove sessions with no track
            for (i = 0; i < sessionsInTrack.length; i++) {
                session = sessionsInTrack[i];
                if ((!idMap[session.get("id")]) && (!cidMap[session.cid])) {
                    this.removeSession(session, true);
                }
            }

            // shift tracks' indexes
            var thisTracks = this.get("track");
            for (var index = track.get("index") + 1; index < thisTracks.length; index++) {
                var currentTrack = thisTracks.where({
                    'index' : index
                })[0];
                currentTrack.set({
                    'index' : index - 1
                });
            }

            // remove track
            thisTracks.remove(track);
            this.wasChangedFromForm = true; // todo remove when editAgendaView have mixins
            this.isSynced = false;
        },

        removeSession : function(session, hasNoTracks) {
            if (!hasNoTracks) {
                var relationsSessionTrack = this.get("relation-session-track");
                relationsSessionTrack.removeAllRelations(session);
            }
            var thisSessions = this.get("session");
            thisSessions.remove(session);
            // NOTICE there is no remove speakers relations- it happens in the DayView.removeSessionView
            this.wasChangedFromForm = true; // todo remove when editAgendaView have mixins
            this.isSynced = false;
        }
    });

    var RelationSessionTrack = SyncedModel.extend({});
    var RelationsSessionTrack = RelationsCollection.extend({
        model : RelationSessionTrack
    });

    return Day;

});
